import React from 'react'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import * as Displays from 'support/displays'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import SmartviewHeader from 'widgets/smartviews/partials/SmartviewHeader'
import { Translation } from '@morningtrain/react-translations'

export default function RevenueBudget () {
  return (
    <>
      <SmartviewHeader>
        <Translation name='revenue_budget' />
      </SmartviewHeader>
      <SmartviewTextGroup highlight>
        <SmartviewText label={<><span><Translation name='forecast' /></span> <Displays.Currency name='forecast' decimals={0} /></>} textSize='text-xs'>
          <div className='flex justify-between'>
            <span><Translation name='last_week' /></span>
            <Displays.Currency name='forecast_last_week' decimals={0} />
          </div>
          <div className='flex justify-between'>
            <span><Translation name='locked_budget' /></span>
            <Displays.Currency name='forecast_locked_budget' decimals={0} />
          </div>
        </SmartviewText>
        <SmartviewText label={<><span><Translation name='adjustment' /></span> <Displays.Currency name='adjustment' decimals={0} /></>} textSize='text-xs'>
          <div className='flex justify-between'>
            <span><Translation name='last_week' /></span>
            <Displays.Currency name='adjustment_last_week' decimals={0} />
          </div>
          <div className='flex justify-between'>
            <span><Translation name='locked_budget' /></span>
            <Displays.Currency name='adjustment_locked_budget' decimals={0} />
          </div>
        </SmartviewText>
        <SmartviewText label={<><span><Translation name='total_forecast' /></span> <Displays.Currency name='total_forecast' decimals={0} /></>} textSize='text-xs'>
          <div className='flex justify-between'>
            <span><Translation name='last_week' /></span>
            <Displays.Currency name='total_forecast_last_week' decimals={0} />
          </div>
          <div className='flex justify-between'>
            <span><Translation name='locked_budget' /></span>
            <Displays.Currency name='total_forecast_locked_budget' decimals={0} />
          </div>
        </SmartviewText>
      </SmartviewTextGroup>

      <SmartviewContentSeparator className='mt-6 mb-5' />

      <div className='flex justify-between items-center'>
        <span className='text-gray-500 text-xs'><Translation name='achieved_revenue_week' data={{ week: 'model:week|' }} /></span>
        <span className='text-base font-medium'><Displays.Currency name='realised_revenue' decimals={0} /></span>
      </div>
    </>
  )
}
